<template>
    <section class="login py-5 password-change">
        <div class="d-flex align-items-center">
            <div class="row w-100 no-gutters">
                <div class="col-lg-4 mx-auto">
                    <img src="@/assets/images/ITA_Airways_Logo.svg" class="login-logo m-auto d-block" alt="" />
                    <div class="card mt-5">
                        <div class="card-header">
                            <div class="alert alert-info mb-0">
                                Stai ancora utilizzando la password temporanea. Per procedere è necessario impostare una nuova password.
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Vecchia password</label>
                                <input type="password" class="form-control" v-model="oldPassword" placeholder="Vecchia password">
                            </div>
                            <div class="form-group">
                                <label>Nuova Password</label>
                                <input type="password" class="form-control" v-model="newPassword" placeholder="Nuova password">
                            </div>
                            <div class="form-group">
                                <label>Conferma nuova Password</label>
                                <input type="password" class="form-control" v-model="newPasswordConfirm" placeholder="Nuova password">
                            </div>
                            <div v-if="$v.$error" class="alert alert-danger">
                                <span v-if="!$v.oldPassword.required">La vecchia password è richiesta.<br></span>
                                <span v-if="!$v.newPassword.required">La nuova password è richiesta.<br></span>
                                <span v-if="!$v.newPassword.minLength">La nuova password deve essere lunga almeno {{ $v.newPassword.$params.minLength.min }} caratteri.<br></span>
                                <span v-if="!$v.newPasswordConfirm.sameAsPassword">Le password devono essere uguali.</span>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button @click="submitForm" class="btn btn-block btn-success">
                                <font-awesome-icon icon="exchange-alt" />
                                CAMBIA PASSWORD
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    required,
    sameAs,
    minLength
} from 'vuelidate/lib/validators'
import {
    CHANGE_PASSWORD
} from '@/store/actions.type'
export default {
    name: 'password-change',
    data () {
        return {
            oldPassword: null,
            newPassword: null,
            newPasswordConfirm: null
        }
    },
    validations: {
        oldPassword: {
            required
        },
        newPassword: {
            required,
            minLength: minLength(8)
        },
        newPasswordConfirm: {
            sameAsPassword: sameAs('newPassword')
        }
    },
    methods: {
        submitForm () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.$store
                    .dispatch(CHANGE_PASSWORD, {
                        oldPassword: this.oldPassword,
                        newPassword: this.newPassword
                    })
                    .then(() => {
                        location.reload()
                    })
            }

        }

    }
}
</script>
<style lang="scss" scoped>
.password-change {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: white;
    z-index: 999999;
    // .card {
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     min-width: 300px;
    // }
}
</style>
